export default __webpack_public_path__ + "2199eaf30bc80626b8badf98f8b003b9.png";